import React, {FunctionComponent, useRef, useState} from "react";
import styles from "./EditSectionModal.module.scss";
import ToggleButtonsEditSections from "../../shared/ui/ToggleButtonsEditSections/ToggleButtonsEditSections";
import {Button} from "@mui/material";
import {SectionHeights, SectionWidth} from "../../../shared";
import TextFieldWithButtons from "../../shared/ui/TextFieldWithButtons/TextFieldWithButtons";
import ResetSection from "../../icons/ResetSection";
import Copy from "../../icons/Copy";
import Remove from "../../icons/Remove/Remove";
import {SectionInterface, StoreWallInterface} from "../../../store/types/store";
import {useShelvingStore} from "../../../store/useShelvingStore";
import {useStoreSystem} from "../../../store";
import shallow from "zustand/shallow";
import {getWallLineVertices} from "../../SceneObjects/ButtonsScene/utils";
import {getCameraPositionToMiddleLine, getTargetPositionToMiddleLine} from "../../../store/helpers";
import {useUpdateNeighboringBrackets} from "../../../hooks/useUpdateNeighboringBrackets";
import {STEP_VALUE} from "../../SceneObjects/room/constants";

type PropsType = {
    activeWidth: SectionWidth;
    activeHeight: SectionHeights;
    setActiveWidth: (width: SectionWidth) => void;
    setActiveHeight: (heights: SectionHeights) => void;
    currentSection: SectionInterface | undefined;
    closeModal: () => void;
    roomHeight: number;
    currentShelf: StoreWallInterface;
    checkAvailableSectionsWidth: (isRemoveSection?: boolean) => boolean;
};
//TODO сильно тут не ковырялся
const EditSectionModalBody: FunctionComponent<PropsType> = ({
                                                                setActiveWidth,
                                                                activeWidth,
                                                                setActiveHeight,
                                                                activeHeight,
                                                                currentSection,
                                                                closeModal,
                                                                roomHeight,
                                                                currentShelf,
                                                                checkAvailableSectionsWidth,
                                                            }) => {
    const {copySection, removeSection} = useShelvingStore(
        (state) => ({
            copySection: state.copySection,
            removeSection: state.removeSection,
        }),
        shallow
    );

    const {currentSide, setSystemProperties} = useStoreSystem(
        (state) => ({
            currentSide: state.currentSide,
            setSystemProperties: state.setSystemProperties,
        }),
        shallow
    );

    const [offsetFloor, setOffsetFloor] = useState<SectionHeights>({
        left: roomHeight - activeHeight.left - currentShelf.offsetCeiling,
        right: roomHeight - activeHeight.right - currentShelf.offsetCeiling,
    });
    const [isFixChangeTwoHeight, setIsFixChangeTwoHeight] = useState<boolean>(false);
    const resetValues = useRef({offsetFloor, activeHeight, activeWidth});

    const updateNeighboringBrackets = useUpdateNeighboringBrackets(currentShelf.sections, currentSection)

    const setFloorCeilingHandler = (ceiling: number, side: "left" | "right") => {
        if (side === "left") {
            const newLeftHeight = activeHeight.left + (offsetFloor.left - ceiling);
            setActiveHeight({left: newLeftHeight, right: isFixChangeTwoHeight ? newLeftHeight : activeHeight.right});
            setOffsetFloor({left: ceiling, right: isFixChangeTwoHeight ? ceiling : offsetFloor.right});
        }
        if (side === "right") {
            const newRightHeight = activeHeight.right + (offsetFloor.right - ceiling);
            setActiveHeight({right: newRightHeight, left: isFixChangeTwoHeight ? newRightHeight : activeHeight.left});
            setOffsetFloor({right: ceiling, left: isFixChangeTwoHeight ? ceiling : offsetFloor.left});
        }
    };

    const setActiveHeightHandler = (height: number, side: "left" | "right") => {
        if (side === "left") {
            const newOffsetFloor = offsetFloor.left + (activeHeight.left - height);
            setOffsetFloor({
                left: newOffsetFloor,
                right: isFixChangeTwoHeight ? newOffsetFloor : offsetFloor.right,
            });
            setActiveHeight({left: height, right: isFixChangeTwoHeight ? height : activeHeight.right});
        }
        if (side === "right") {
            const newOffsetFloor = offsetFloor.right + (activeHeight.right - height);
            setOffsetFloor({right: newOffsetFloor, left: isFixChangeTwoHeight ? newOffsetFloor : offsetFloor.left});
            setActiveHeight({right: height, left: isFixChangeTwoHeight ? height : activeHeight.left});
        }
    };

    const resetValuesHandler = () => {
        setActiveHeight(resetValues.current.activeHeight);
        setOffsetFloor(resetValues.current.offsetFloor);
        setActiveWidth(resetValues.current.activeWidth);
    };

    const copySectionHandler = () => {
        currentSection && copySection(currentSection);
        closeModal();
        setCamera();
    };

    const removeSectionHandler = () => {
        if (checkAvailableSectionsWidth(true)) {
            currentSection && removeSection(currentSection);
            updateNeighboringBrackets()
            closeModal();
            setCamera();
        }
    };

    const setCamera = () => {
        const lineVertices = getWallLineVertices(currentSide);
        setSystemProperties([
            {name: "cameraPosition", value: getCameraPositionToMiddleLine(lineVertices)},
            {name: "targetCameraPosition", value: getTargetPositionToMiddleLine(lineVertices)},
        ]);
    };

    const availebleWidth = currentSection && currentSection.items.length > 0 ? [currentSection?.width] : [800, 600, 480];

    return (
        <>
            <div className={styles.header}>
                {`Секция ${activeWidth}х${
                    activeHeight.right >= activeHeight.left ? activeHeight.right : activeHeight.left
                }`}
            </div>
            <div className={styles.body}>
                <div className={styles.widthSizes}>
                    <span className={styles.title}>Ширина</span>
                    <div className={styles.content}>
                        <ToggleButtonsEditSections
                            activeWidth={activeWidth}
                            setActiveWidth={setActiveWidth}
                            sectionSizes={availebleWidth}
                        />
                    </div>
                </div>
                <div className={styles.heightSizes}>
                    <div className={styles.leftGroup}>
                        <div className={styles.titleGroup}>
                            Левая стойка
                            <button
                                className={
                                    isFixChangeTwoHeight ? `${styles.lockBtn} ${styles.lockBtnActive}` : styles.lockBtn
                                }
                                onClick={() => {
                                    if (!isFixChangeTwoHeight) {
                                        setActiveHeightHandler(activeHeight.left, 'left')
                                        setActiveHeightHandler(activeHeight.left, 'right')
                                    }
                                    setIsFixChangeTwoHeight((prevState) => !prevState)
                                }}
                            >
                                <svg
                                    width="16"
                                    height="17"
                                    viewBox="0 0 16 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M10.0878 6.4122C9.7715 6.09588 9.25864 6.0959 8.94232 6.41223C8.626 6.72856 8.62602 7.24143 8.94235 7.55774L10.0878 6.4122ZM9.51509 11.529L8.94235 10.9562L8.94234 10.9562L9.51509 11.529ZM6.48509 14.559L7.05785 15.1317H7.05785L6.48509 14.559ZM1.94109 10.015L2.51385 10.5877H2.51385L1.94109 10.015ZM4.02885 9.07273C4.34517 8.7564 4.34517 8.24354 4.02885 7.92721C3.71253 7.61089 3.19966 7.61089 2.88334 7.92721L4.02885 9.07273ZM5.91235 10.5877C6.22869 10.9041 6.74155 10.904 7.05787 10.5877C7.37418 10.2714 7.37417 9.75851 7.05783 9.4422L5.91235 10.5877ZM6.48509 5.47097L7.05783 6.04374L7.05785 6.04373L6.48509 5.47097ZM9.51509 2.44097L10.0879 3.01373V3.01373L9.51509 2.44097ZM14.0591 2.44097L13.4863 3.01373V3.01373L14.0591 2.44097ZM14.0591 6.98497L14.6319 7.55773V7.55773L14.0591 6.98497ZM11.9713 7.92721C11.655 8.24354 11.655 8.7564 11.9713 9.07273C12.2877 9.38905 12.8005 9.38905 13.1168 9.07273L11.9713 7.92721ZM8.94235 7.55774C9.39303 8.0084 9.64622 8.61963 9.64622 9.25697H11.2662C11.2662 8.18996 10.8423 7.16666 10.0878 6.4122L8.94235 7.55774ZM9.64622 9.25697C9.64622 9.89431 9.39303 10.5055 8.94235 10.9562L10.0878 12.1017C10.8423 11.3473 11.2662 10.324 11.2662 9.25697H9.64622ZM8.94234 10.9562L5.91234 13.9862L7.05785 15.1317L10.0878 12.1017L8.94234 10.9562ZM5.91234 13.9862C4.97387 14.9247 3.45232 14.9247 2.51385 13.9862L1.36834 15.1317C2.93945 16.7028 5.48673 16.7028 7.05785 15.1317L5.91234 13.9862ZM2.51385 13.9862C1.57538 13.0477 1.57538 11.5262 2.51385 10.5877L1.36834 9.44221C-0.202779 11.0133 -0.202779 13.5606 1.36834 15.1317L2.51385 13.9862ZM2.51385 10.5877L4.02885 9.07273L2.88334 7.92721L1.36834 9.44221L2.51385 10.5877ZM7.05783 9.4422C6.60715 8.99154 6.35396 8.38031 6.35396 7.74297H4.73396C4.73396 8.80998 5.15784 9.83328 5.91235 10.5877L7.05783 9.4422ZM6.35396 7.74297C6.35396 7.10563 6.60715 6.4944 7.05783 6.04374L5.91235 4.8982C5.15784 5.65266 4.73396 6.67596 4.73396 7.74297H6.35396ZM7.05785 6.04373L10.0879 3.01373L8.94234 1.86821L5.91234 4.89821L7.05785 6.04373ZM10.0879 3.01373C11.0263 2.07526 12.5479 2.07526 13.4863 3.01373L14.6319 1.86821C13.0607 0.297099 10.5135 0.297099 8.94234 1.86821L10.0879 3.01373ZM13.4863 3.01373C14.4248 3.95219 14.4248 5.47375 13.4863 6.41222L14.6319 7.55773C16.203 5.98661 16.203 3.43933 14.6319 1.86821L13.4863 3.01373ZM13.4863 6.41221L11.9713 7.92721L13.1168 9.07273L14.6319 7.55773L13.4863 6.41221Z"
                                        fill="#838280"
                                    />
                                </svg>
                            </button>
                        </div>

                        <div className={styles.bodyItem}>
                            <span className={styles.label}>Высота</span>
                            <div className={styles.content}>
                                <TextFieldWithButtons
                                    isEval={true}
                                    autoFocus={false}
                                    min={100}
                                    max={currentShelf.height}
                                    step={50}
                                    objValue={activeHeight.left}
                                    setObjValue={(height) => setActiveHeightHandler(height, "left")}
                                    hotChangeValue={true}
                                />
                            </div>
                        </div>
                        <div className={styles.bodyItem}>
                            <span className={styles.label}>Отступ от пола</span>
                            <div className={styles.content}>
                                <TextFieldWithButtons
                                    isEval={true}
                                    autoFocus={false}
                                    min={roomHeight - currentShelf.height - currentShelf.offsetCeiling}
                                    //FIXME почему тут 100
                                    max={roomHeight - currentShelf.offsetCeiling - 100}
                                    step={STEP_VALUE}
                                    objValue={offsetFloor.left}
                                    setObjValue={(ceiling) => setFloorCeilingHandler(ceiling, "left")}
                                    hotChangeValue={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={styles.rightGroup}>
                        <div className={styles.titleGroup}>Правая стойка</div>
                        {!isFixChangeTwoHeight && (
                            <>
                                <div className={styles.bodyItem}>
                                    <div className={styles.content}>
                                        <TextFieldWithButtons
                                            isEval={true}
                                            autoFocus={false}
                                            min={100}
                                            max={currentShelf.height}
                                            step={50}
                                            objValue={activeHeight.right}
                                            setObjValue={(height) => setActiveHeightHandler(height, "right")}
                                            hotChangeValue={true}
                                        />
                                    </div>
                                </div>
                                <div className={styles.bodyItem}>
                                    <div className={styles.content}>
                                        <TextFieldWithButtons
                                            isEval={true}
                                            autoFocus={false}
                                            min={roomHeight - currentShelf.height - currentShelf.offsetCeiling}
                                            max={roomHeight - currentShelf.offsetCeiling - 100}
                                            step={50}
                                            objValue={offsetFloor.right}
                                            setObjValue={(ceiling) => setFloorCeilingHandler(ceiling, "right")}
                                            hotChangeValue={true}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <div className={styles.buttons}>
                <Button className={styles.btn} variant="contained" onClick={resetValuesHandler}>
                    <span>Сброс</span>
                    <ResetSection/>
                </Button>
                <Button className={styles.btn} variant="contained" onClick={copySectionHandler}>
                    <span>Копировать</span>
                    <Copy/>
                </Button>
                <Button className={styles.btn} variant="contained" onClick={removeSectionHandler}>
                    <span>Удалить</span>
                    <Remove/>
                </Button>
            </div>
        </>
    );
};

export default EditSectionModalBody;
